import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import FbLogo from "../../../assets/images/icons/fb.png";
import LinkedInLogo from "../../../assets/images/icons/linkedin.png";
import YtLogo from "../../../assets/images/icons/youtube.png";
import companyLogo from "../../../assets/images/Agahi Logo White.png";
import sdms from "../../../assets/images/sdms.png";

const FooterTopComp = ({ show, getProducts, setModalShow, modalShow }) => {
	const [categories, setCategories] = useState([]);

	const navigate = useNavigate();
	// const getCategories = () => {
	// 	CoreHttpHandler.request(
	// 		"products",
	// 		"categories",
	// 		{},
	// 		(response) => {
	// 			const res = response.data.data.data.data;
	// 			const firstFour = res.length > 4 ? res.slice(0, 4) : "";
	// 			setCategories(res.length > 4 ? firstFour : res);
	// 		},
	// 		(err) => {
	// 			console.log(err);
	// 		}
	// 	);
	// };

	// useEffect(() => {
	// 	if (!show) {
	// 		getCategories();
	// 	}
	// }, [show]);

	return (
		<>
			<div className='footer_top_wrap'>
				<Container className="my-4">
					<Row>
						<Col xl={3} lg={4} md={12} xs={12} className="mb-4">
							<div className='col col1'>
								<Link to='/'>
									<img
										src={companyLogo}
										alt='logo'
										width="90%"
									/>
								</Link>
							</div>

						</Col>
						<Col xl={3} lg={2} md={6} xs={6}>

							<div className='col col2'>
								<ul className='menu_wrap'>
									<h4>Important Links</h4>
									<li>
										<Link target="_blank" to='https://www.secp.gov.pk/'>SECP</Link>
									</li>
									<li>
										<Link target="_blank" to='https://picg.org.pk/'>PICG</Link>
									</li>
									<li>
										<Link target="_blank" to='https://www.cdcpakistan.com/'>CDC</Link>
									</li>
									<li>
										<Link target="_blank" to='https://www.psx.com.pk/'>PSX</Link>
									</li>
									<li>
										<Link target="_blank" to='https://www.sbp.org.pk/index.html'>SBP</Link>
									</li>
								</ul>
							</div>
						</Col>
						<Col xl={3} lg={2} md={6} xs={6}>

							<div className='col col3'>
								<ul className='menu_wrap'>
									<h4>Sitemap</h4>
									<li>
										<Link to='/'>Home</Link>
									</li>
									<li>
										<Link to='/ShareHoldersRights/Documents'>Shareholder  Rights</Link>
									</li>
									<li>
										<Link to='/ShareHolderEducation/learning'>Shareholder  Education</Link>
									</li>
									<li>
										<Link to='/Library/Legal&RegulatoryInformation'>Library</Link>
									</li>
									<li>
										<Link to='/E-service/CompanyMeeting&Announcements'>Investor Information</Link>
									</li>
									<li>
										<Link to='/contact'>Contact</Link>
									</li>
								</ul>
							</div>
						</Col>
						<Col xl={3} lg={4} md={12} xs={12}>

							<div className='col col4'>
								<ul className='menu_wrap'>
									<h4>Follow Us</h4>
									<Container>
										<Row className='d-flex align-items-center justify-content-center social_links'>

											<Col xs={4} lg={4}>
												<Link target="_blank" to='https://www.facebook.com/PICG.org.pk/'>
													<img src={FbLogo} />
												</Link>
											</Col>
											{/* <Col xs={3} lg={3}>
												<Link target="_blank" to='https://picg.org.pk/'>
													<img src={InstaLogo} />
												</Link>
											</Col> */}
											<Col xs={4} lg={4}>
												<Link target="_blank" to='https://www.linkedin.com/company/picg/mycompany/'>
													<img src={LinkedInLogo} />
												</Link>
											</Col>
											<Col xs={4} lg={4}>
												<Link target="_blank" to='https://www.youtube.com/@pakinstituteofcg'>
													<img src={YtLogo} />
												</Link>
											</Col>
										</Row>
										<Row className="mt-4">

											<Col xs={12}>
												<Link target="_blank" to='https://sdms.secp.gov.pk/'>
													<img width={"100%"} src={sdms} />
												</Link>
											</Col>
										</Row>

									</Container>

								</ul>
							</div>
						</Col>

					</Row>
					<Row>
						<p>
							<span style={{ fontSize: "18px" }}>Disclaimer: </span>Welcome to Shareholder Agahi, a collaborative initiative by the Pakistan Institute of Corporate Governance (PICG) and the Central Depository Company of Pakistan (CDC). The content and services provided on this platform are intended to enhance shareholder awareness and understanding of their rights and responsibilities, as well as to offer them tools to enhance active participation during general meetings and other shareholder events.
							<span style={{ cursor: "pointer",color:"rgb(61 221 135)" }} onClick={() => setModalShow(true)}> Read more</span>
						</p>
					</Row>
				</Container>

			</div>
		</>
	);
};

export default FooterTopComp;
